// Import specific constants
import { NODES_EXTRA_DATA } from '../nodes/constants';
import { NodeEnum } from '../types';

export * from '../nodes/constants';

// TODO
export const ALL_AVAILABLE_BLOCKS = Object.keys(NODES_EXTRA_DATA).filter(
  (key) => key !== NodeEnum.Start,
) as NodeEnum[];

export const NODE_WIDTH = 240;
export const X_OFFSET = 60;
export const NODE_WIDTH_X_OFFSET = NODE_WIDTH + X_OFFSET;
export const Y_OFFSET = 39;
export const MAX_TREE_DEEPTH = 50;
export const START_INITIAL_POSITION = { x: 80, y: 282 };
export const AUTO_LAYOUT_OFFSET = {
  x: -42,
  y: 243,
};
export const ITERATION_NODE_Z_INDEX = 1;
export const ITERATION_PADDING = {
  top: 85,
  right: 16,
  bottom: 20,
  left: 16,
};

export const CUSTOM_NODE = 'custom' as string;
export const WORKFLOW_DATA_UPDATE = 'WORKFLOW_DATA_UPDATE';
